@if (initialized) {
<!--    <p-tabView [(activeIndex)]="activeIndex">-->

<!--        <p-tabPanel header="Basic Detail">-->
<!--            @if (activeIndex == 0 && jobInstanceBasicWidget) {-->
<!--                <mvs-widget [widgetData]="jobInstanceBasicWidget"></mvs-widget>-->
<!--            }-->
<!--        </p-tabPanel>-->


<!--        <p-tabPanel header="Steps Execution">-->
<!--            @if (activeIndex == 1 && jobInstanceStepExecutionWidget) {-->
<!--                <mvs-widget [widgetData]="jobInstanceStepExecutionWidget"></mvs-widget>-->
<!--            }-->
<!--        </p-tabPanel>-->


<!--        <p-tabPanel header="Parameters">-->
<!--            @if (activeIndex == 2 && jobInstanceParametersWidget) {-->
<!--                <mvs-widget [widgetData]="jobInstanceParametersWidget"></mvs-widget>-->
<!--            }-->
<!--        </p-tabPanel>-->

<!--    </p-tabView>-->
    <p-tabs [(value)]="activeIndex">
        <p-tablist>
            <p-tab [value]="0">Basic Detail</p-tab>
            <p-tab [value]="1">Steps Execution</p-tab>
            <p-tab [value]="2">Parameters</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel [value]="0">
                @if (activeIndex == 0 && jobInstanceBasicWidget) {
                    <mvs-widget [widgetData]="jobInstanceBasicWidget"></mvs-widget>
                }
            </p-tabpanel>

            <p-tabpanel [value]="1">
                @if (activeIndex == 1 && jobInstanceStepExecutionWidget) {
                    <mvs-widget [widgetData]="jobInstanceStepExecutionWidget"></mvs-widget>
                }
            </p-tabpanel>

            <p-tabpanel [value]="2">
                @if (activeIndex == 2 && jobInstanceParametersWidget) {
                    <mvs-widget [widgetData]="jobInstanceParametersWidget"></mvs-widget>
                }
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>

}